import React from "react";
import { 
  Mail, 
  Phone, 
  MapPin, 
  ExternalLink, 
  ArrowUp,
  Code,
  Shield
} from "lucide-react";
import { mockData } from "../mock/mockData";

const Footer = () => {
  const { contact } = mockData;
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1C3C73] to-[#252F4A] text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 border border-white/10 rounded-full"></div>
        <div className="absolute top-1/2 left-1/3 w-4 h-4 bg-white/10 rounded-full"></div>
      </div>

      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-2">
              <div className="text-2xl font-bold bg-gradient-to-r from-[#3E97FF] to-[#27AE60] bg-clip-text text-transparent">
                Infinitux
              </div>
              <div className="text-2xl font-light text-white">Solutions</div>
            </div>
            <p className="text-white/80 leading-relaxed">
              Transformamos ideas en soluciones digitales que potencian el crecimiento empresarial 
              con tecnología de vanguardia y servicios especializados.
            </p>
            {/* <div className="flex space-x-4">
              <a 
                href={contact.socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#3E97FF] text-white rounded-lg flex items-center justify-center transition-colors"
              >
                <ExternalLink className="w-5 h-5" />
              </a>
              <a 
                href={contact.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#3E97FF] text-white rounded-lg flex items-center justify-center transition-colors"
              >
                <ExternalLink className="w-5 h-5" />
              </a>
              <a 
                href={contact.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-[#FF6B35] text-white rounded-lg flex items-center justify-center transition-colors"
              >
                <ExternalLink className="w-5 h-5" />
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-white">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="text-white/80 hover:text-[#3E97FF] transition-colors block"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('nosotros')}
                  className="text-white/80 hover:text-[#3E97FF] transition-colors block"
                >
                  Sobre Nosotros
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('servicios')}
                  className="text-white/80 hover:text-[#3E97FF] transition-colors block"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('productos')}
                  className="text-white/80 hover:text-[#3E97FF] transition-colors block"
                >
                  Productos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-white/80 hover:text-[#3E97FF] transition-colors block"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-white">Nuestros Productos</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-3">
                <Shield className="w-5 h-5 text-[#3E97FF]" />
                <div>
                  <div className="text-white font-medium">MiPila</div>
                  <div className="text-white/60 text-sm">Seguridad Social</div>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Code className="w-5 h-5 text-[#27AE60]" />
                <div>
                  <div className="text-white font-medium">Recobra360</div>
                  <div className="text-white/60 text-sm">Gestión de Recobros</div>
                </div>
              </li>
            </ul>
            <div className="pt-4">
              <h4 className="text-lg font-semibold text-white mb-3">Servicios</h4>
              <ul className="space-y-2 text-sm">
                <li className="text-white/70">• Desarrollo Web</li>
                <li className="text-white/70">• Aplicaciones Móviles</li>
                <li className="text-white/70">• Consultoría Tecnológica</li>
                <li className="text-white/70">• Gestión Empresarial</li>
              </ul>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-white">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#3E97FF] mt-1" />
                <div>
                  <div className="text-white font-medium">Email</div>
                  <a 
                    href={`mailto:${contact.email}`}
                    className="text-white/80 hover:text-[#3E97FF] transition-colors text-sm"
                  >
                    {contact.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#070707] mt-1" />
                <div>
                  <div className="text-white font-medium">Teléfono</div>
                  <a 
                    href={`tel:${contact.phone}`}
                    className="text-white/80 hover:text-[#070707] transition-colors text-sm"
                  >
                    {contact.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <svg className="w-5 h-5 text-[#27AE60]" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
                <div>
                  <div className="text-white font-medium">WhatsApp</div>
                  <a 
                    href={`https://wa.me/${contact.phone.replace(/\D/g, '')}?text=${encodeURIComponent('Quiero más información en Infinitux Solutions!')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/80 hover:text-[#27AE60] transition-colors text-sm"
                  >
                    {contact.phone}
                  </a>
                </div>
              </li>
              {/* <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#FF6B35] mt-1" />
                <div>
                  <div className="text-white font-medium">Dirección</div>
                  <p className="text-white/80 text-sm leading-relaxed">
                    {contact.address}
                  </p>
                </div>
              </li> */}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/60 text-sm">
              © {currentYear} Infinitux Solutions. Todos los derechos reservados.
            </div>
            <div className="flex space-x-6 text-sm">
              <button className="text-white/60 hover:text-white transition-colors">
                Política de Privacidad
              </button>
              <button className="text-white/60 hover:text-white transition-colors">
                Términos de Uso
              </button>
            </div>
          </div>
        </div>

        {/* Scroll to Top Button */}
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 w-12 h-12 bg-[#3E97FF] hover:bg-[#1C3C73] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center z-50 group"
        >
          <ArrowUp className="w-5 h-5 group-hover:scale-110 transition-transform" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;